import { Capacitor } from "@capacitor/core";

declare global {
  interface Window {
    /** Set at runtime when native bundle id is co.buukd.explore */
    __BUUKD_IS_EXPLORE_APP__?: boolean;
  }
}

/** Call from explore-main after Capacitor App.getInfo() (native co.buukd.explore). */
export function markExploreNativeApp(): void {
  if (typeof window !== "undefined") {
    window.__BUUKD_IS_EXPLORE_APP__ = true;
  }
}

/** True for Explore web build or Buukd Explore native app (not the business app). */
export function isExploreAppVariant(): boolean {
  if (import.meta.env.VITE_APP_VARIANT === "explore") return true;
  if (typeof window !== "undefined" && window.__BUUKD_IS_EXPLORE_APP__ === true) return true;
  return false;
}

export function isNativeIosApp(): boolean {
  return Capacitor.getPlatform() === "ios";
}

export function isNativeApp(): boolean {
  return Capacitor.isNativePlatform();
}

/** Main Buukd business app (co.buukd.app), not the Explore consumer shell. */
export function isBuukdBusinessNativeApp(): boolean {
  return Capacitor.isNativePlatform() && !isExploreAppVariant();
}
